import { m } from "@recobra/i18n/messages";
import type { DocumentType } from "@recobra/schemas/document";

/** Reads out every type that answers a requirement: "Orçamento de reparo ou NF do reparo". */
export const acceptedDocumentTypesLabel = (documentTypes: readonly DocumentType[]): string =>
  documentTypes
    .map((documentType) => m.document_type_label({ documentType }))
    .join(` ${m.common_or()} `);
